import { GenericAnalyticsClient } from '@acorns/web-utils'
import { compose, withProps, withPropsOnChange } from 'recompose'

type GlobalUserProps = {
  mobileUuid?: string
  mobileSessionId?: string
}

type Props = {
  analytics: GenericAnalyticsClient
  data?: {
    loading: boolean
    user?: {
      uuid: string
    }
  }
}

// TYPEFIX_TODO: I'm guessing most implementations of this component are not working as expected as `data` prop is implicitly expected
export default compose<any, {}>(
  withProps<GlobalUserProps, Props>(({ data }) => {
    if (!data?.loading) {
      return {
        mobileUuid: window.mobileUuid,
        mobileSessionId: window.mobileSessionId,
      }
    }
    return {}
  }),
  withPropsOnChange<void, Props & GlobalUserProps>(
    ['data'],
    ({ analytics, data, mobileUuid, mobileSessionId }) => {
      if (!data?.loading && (mobileUuid !== undefined || data?.user?.uuid)) {
        // Note: Identify the user once for analytic events
        const userId = mobileUuid || data?.user?.uuid

        analytics.setContext({
          sessionId: mobileSessionId,
        })

        analytics.identify(userId, {
          userId,
        })
      }
    },
  ),
)
